import { render, staticRenderFns } from "./PosTransactionDetails.vue?vue&type=template&id=0b6dfc70&scoped=true"
import script from "./PosTransactionDetails.vue?vue&type=script&lang=js"
export * from "./PosTransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./PosTransactionDetails.vue?vue&type=style&index=0&id=0b6dfc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6dfc70",
  null
  
)

export default component.exports